import React, { useMemo, useEffect } from 'react';
import Typography from '@mui/material/Typography';
import { useDispatch } from 'react-redux';
import ButtonScogoClosedOutlined from '../../../../common/Buttons/ButtonScogoClosedOutlined';
import { RenderBankDetails } from './RenderBankDetails';
import { RenderKycDetails } from './RenderKycDetails';
import { RenderPartnerDetails } from './RenderPartnerDetails';
import { RenderTags } from './RenderTags';
import { closeModalAction } from '../../../../actions/modal';
import IconToolTip from '../../../../common/IconToolTip';
import { SkeltonCardTwo } from '../../../../common/SkeltonCardTwo';
import { getUserDetailsByID, rejectVerifyUser, verifyUser } from '../../../../actions/users';
import { useSelector } from 'react-redux';
import ButtonScogoPrimary from '../../../../common/Buttons/ButtonScogoPrimary';
import ButtonScogoClosed from '../../../../common/Buttons/ButtonScogoClosed';
const formName = 'Verify_User';

export default function RenderVerifyUser({ userId }) {
    const [expanded, setExpanded] = React.useState('panel1');
    const dispatch = useDispatch();
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);

    const userDetailsById = useSelector((state) => state.user.userDetailsById);
    const isUserDetailsByIdLoading = useSelector((state) => state.loading.isUserDetailsByIdLoading);


    const memoizedUserDetails = useMemo(() => {
        let data = { user: {}, org: {} };
        if (userDetailsById[userId]) {
            data = userDetailsById[userId];
        }
        return data;
    }, [userDetailsById, userId]);

    useEffect(() => {
        if (userId && !userDetailsById[userId]) {
            dispatch(getUserDetailsByID({ user_id: userId }));
        }
    }, [userId, dispatch]);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const onCancel = () => {
        dispatch(closeModalAction());
    };


    if (isUserDetailsByIdLoading) {
        return <div className='flex justify-center items-center h-full px-6'>
            <SkeltonCardTwo arr={[1, 2, 3, 4]} height={20} />
        </div>
    }

    const onVerify = () => {
        dispatch(verifyUser({ userId, formName }))
    };

    const onReject = () => {
        dispatch(rejectVerifyUser({ userId, formName }))
    };

    return (
        <div className='h-auto relative overflow-hidden max-h-[65vh]'>
            <div className='max-h-[54vh] overflow-y-auto flex-1'>
                <RenderPartnerDetails user={memoizedUserDetails.user} expanded={expanded} handleChange={handleChange} />
                <RenderKycDetails user={memoizedUserDetails.user} kyc={memoizedUserDetails.user.kyc} expanded={expanded} handleChange={handleChange} />
                <RenderBankDetails user={memoizedUserDetails.user} bank={memoizedUserDetails.user.bank} expanded={expanded} handleChange={handleChange} />
                <RenderTags user={memoizedUserDetails.user} expanded={expanded} handleChange={handleChange} />
            </div>
            <div className={`px-6 py-4 flex gap-2 justify-end mt-4 relative`}>
                <ButtonScogoClosedOutlined textOrComponent='Cancel' onClick={onCancel} />
                <ButtonScogoClosed loading={formButtonLoading[formName]} textOrComponent='Reject' onClick={onReject} />
                <ButtonScogoPrimary loading={formButtonLoading[formName]} textOrComponent='Verify' onClick={onVerify} />
            </div>
        </div>
    );
};

export const RenderHeader = ({ title, isVerfied = true }) => {
    return <Typography sx={{ width: '100%', flexShrink: 0, fontSize: '1.1rem' }} className='text-scogobgsky'>
        <div className='flex items-center gap-2'>
            <span>{title}</span>
            <IconToolTip title={`${isVerfied ? `${title} verified` : `${title} not verified`}`}>
                {<span className={`material-icons text-font13 ${isVerfied ? 'text-scogosuccess' : 'text-scogoorange'}`}>{isVerfied ? 'verified' : 'pending_actions'}</span>}
            </IconToolTip>
        </div>
    </Typography>
};